// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-size: cover !important;
  background-position: center bottom !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-image: url('home-bg.png') !important;
}

.payment-success-content .container {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.logo-section {
  text-align: center;
  margin-bottom: 10px;
}
.logo-section .brand-logo {
  width: 121.15px;
  height: 115.49px;
}

.success-card {
  background: white;
  padding: 32px 24px;
  margin-bottom: 15px;
  border: 0.6px solid #aeaead;
  border-radius: 4px;
}

.title-message {
  text-align: center;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0%;
  text-align: center;
}

.thank-you-message {
  text-align: center;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  color: var(--color-grey);
  margin-bottom: 8px;
}

.cocktail-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  zoom: var(--zoom);
}
.cocktail-block .cocktail {
  height: 20px;
  width: 20px;
}
.cocktail-block .cocktail-text {
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  text-wrap: balance;
}

.order-details {
  margin-bottom: 24px;
  padding-bottom: 24px;
  padding-top: 24px;
  border-bottom: 0.5px solid #939393;
  border-top: 0.5px solid #939393;
}
.order-details .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.order-details .detail-row:last-child {
  margin-bottom: 0;
}
.order-details .detail-row .detail-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  color: #5c5c5c;
}
.order-details .detail-row .detail-label ion-icon {
  font-size: 18px;
  color: #5c5c5c;
}
.order-details .detail-row .detail-value {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  color: #1d1d1b;
  text-align: right;
}
.order-details .detail-row .detail-value .order-number {
  font-weight: 600;
}

.preparing-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #5c5c5c;
  font-size: 13px;
}
.preparing-status ion-spinner {
  width: 16px;
  height: 16px;
}

.download-receipt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--ion-color-secondary);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.download-receipt:hover {
  background: var(--ion-color-secondary-tint);
}
.download-receipt span {
  font-family: AppFontMedium;
  font-size: 12px;
  font-weight: 500;
  color: #000;
}
.download-receipt ion-icon {
  width: 14px;
  height: 14px;
}

.order-items {
  margin-bottom: 24px;
}
.order-items .item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.order-items .item-row .item-info {
  display: flex;
  gap: 8px;
  flex: 1;
}
.order-items .item-row .item-info .item-quantity {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1b;
}
.order-items .item-row .item-info .item-name {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  color: #1d1d1b;
}
.order-items .item-row .item-price {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1b;
  white-space: nowrap;
  margin-left: 16px;
}
.order-items .item-option {
  padding-left: 32px;
  margin-bottom: 8px;
  font-family: "AppFont", sans-serif;
  font-size: 13px;
  color: #5c5c5c;
}
.order-items .tip-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}

.miles-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}
.miles-row .miles-img {
  height: 18px;
  width: auto;
}
.miles-row .miles-value {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #226086;
}

.total-section {
  padding: 20px 0;
  border-top: 0.5px solid #939393;
}
.total-section .total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-section .total-row .total-label,
.total-section .total-row .total-amount {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  color: #000000;
}

.review-section {
  text-align: center;
}
.review-section .review-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: var(--ion-color-primary);
  border: 0.5px solid #000;
  box-shadow: 1px 1px 0px 1px #000;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  width: 278px;
  height: 44px;
  color: #000000;
}
.review-section .review-button span {
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  color: inherit;
}
.review-section .review-button span:last-child {
  font-family: AppFontBold;
}
.review-section .review-button ion-icon {
  height: 18px;
  width: 18px;
  margin-right: 5px;
}
.review-section .review-button .feedback-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-message {
  text-align: center;
  margin-bottom: 16px;
  margin-top: auto;
}
.footer-message p {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #5c5c5c;
  margin: 0;
}

ion-footer {
  padding: 16px;
  background: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);
  backdrop-filter: blur(4px);
}

@media (max-width: 768px) {
  .payment-success-content .container {
    height: 100%;
    padding: 26px 16px;
  }
  .success-card {
    padding: 20px 12px;
  }
  .logo-section .brand-logo {
    width: 220px;
  }
}
@media (max-width: 480px) {
  .detail-row {
    align-items: flex-start !important;
    gap: 8px;
  }
  .detail-row .detail-value {
    text-align: left !important;
  }
  .order-details .detail-row .detail-label {
    font-size: 13px;
  }
  .order-details .detail-row .detail-value {
    font-size: 13px;
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-overlay ion-spinner {
  width: 48px;
  height: 48px;
  color: white;
}

.error-message {
  background: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  text-align: center;
  font-family: "AppFont", sans-serif;
  font-size: 14px;
}

.status-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  --local-color: var(--ion-color-secondary);
}
.status-tabs .status-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.status-tabs .status-tab .status-indicator {
  width: 100%;
  height: 10px;
  background: #e0e0e0;
  transition: background 0.3s ease;
}
.status-tabs .status-tab span {
  font-family: AppFont, sans-serif;
  font-size: 13px;
  color: #1a1a18;
}
.status-tabs .status-tab.active .status-indicator {
  background: var(--local-color);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACC,iCAAA;EACA,6CAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;AADD;;AAKC;EACC,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAOA;EACC,kBAAA;EACA,mBAAA;AAJD;AAMC;EACC,eAAA;EACA,gBAAA;AAJF;;AASA;EACC,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAND;;AAUA;EACC,kBAAA;EACA,mBAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AARD;;AAYA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,wBAAA;EACA,kBAAA;AAVD;;AAaA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;AAVD;AAYC;EACC,YAAA;EACA,WAAA;AAVF;AAaC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;AAZF;;AAiBA;EACC,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kCAAA;EACA,+BAAA;AAdD;AAgBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAdF;AAgBE;EACC,gBAAA;AAdH;AAiBE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AAfH;AAiBG;EACC,eAAA;EACA,cAAA;AAfJ;AAmBE;EACC,kCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAjBH;AAmBG;EACC,gBAAA;AAjBJ;;AAwBA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AArBD;AAuBC;EACC,WAAA;EACA,YAAA;AArBF;;AA0BA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,sCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AAvBD;AAyBC;EACC,2CAAA;AAvBF;AA0BC;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAxBF;AA2BC;EACC,WAAA;EACA,YAAA;AAzBF;;AA8BA;EACC,mBAAA;AA3BD;AA6BC;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AA3BF;AA6BE;EACC,aAAA;EACA,QAAA;EACA,OAAA;AA3BH;AA6BG;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA3BJ;AA8BG;EACC,kCAAA;EACA,eAAA;EACA,cAAA;AA5BJ;AAgCE;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AA9BH;AAkCC;EACC,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AAhCF;AAmCC;EACC,gBAAA;EACA,iBAAA;EACA,8BAAA;AAjCF;;AAsCA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AAnCD;AAqCC;EACC,YAAA;EACA,WAAA;AAnCF;AAsCC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApCF;;AAyCA;EACC,eAAA;EACA,+BAAA;AAtCD;AAwCC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAtCF;AAwCE;;EAEC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AAtCH;;AA4CA;EACC,kBAAA;AAzCD;AA2CC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,oCAAA;EACA,wBAAA;EACA,gCAAA;EAEA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AA1CF;AA4CE;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AA1CH;AA4CG;EACC,wBAAA;AA1CJ;AA8CE;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AA5CH;AA+CE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AA7CH;;AAmDA;EACC,kBAAA;EACA,mBAAA;EACA,gBAAA;AAhDD;AAkDC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAhDF;;AAoDA;EACC,aAAA;EACA,4GAAA;EACA,0BAAA;AAjDD;;AAqDA;EACC;IACC,YAAA;IACA,kBAAA;EAlDA;EAqDD;IACC,kBAAA;EAnDA;EAsDD;IACC,YAAA;EApDA;AACF;AAuDA;EACC;IACC,kCAAA;IACA,QAAA;EArDA;EAuDA;IACC,2BAAA;EArDD;EAyDD;IACC,eAAA;EAvDA;EA0DD;IACC,eAAA;EAxDA;AACF;AA4DA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA1DD;AA4DC;EACC,WAAA;EACA,YAAA;EACA,YAAA;AA1DF;;AA+DA;EACC,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AA5DD;;AAgEA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yCAAA;AA7DD;AA+DC;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AA7DF;AA+DE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AA7DH;AAgEE;EACC,gCAAA;EACA,eAAA;EACA,cAAA;AA9DH;AAkEG;EACC,8BAAA;AAhEJ","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tbackground-size: cover !important;\n\tbackground-position: center bottom !important;\n\tbackground-repeat: no-repeat !important;\n\tbackground-attachment: fixed !important;\n\tbackground-image: url('../../../assets/bjorn/home-bg.png') !important;\n}\n\n.payment-success-content {\n\t.container {\n\t\tmax-width: 720px;\n\t\tmargin: 0 auto;\n\t\tpadding: 24px 20px;\n\t\tmin-height: 100vh;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n}\n\n// Logo Section\n.logo-section {\n\ttext-align: center;\n\tmargin-bottom: 10px;\n\n\t.brand-logo {\n\t\twidth: 121.15px;\n\t\theight: 115.49px;\n\t}\n}\n\n// Success Card\n.success-card {\n\tbackground: white;\n\tpadding: 32px 24px;\n\tmargin-bottom: 15px;\n\tborder: 0.6px solid #aeaead;\n\tborder-radius: 4px;\n}\n\n// Title Message\n.title-message {\n\ttext-align: center;\n\tmargin-bottom: 20px;\n\n\tfont-size: 14px;\n\tline-height: 135%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n}\n\n// Thank You Message\n.thank-you-message {\n\ttext-align: center;\n\tfont-size: 12px;\n\tline-height: 135%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\n\tcolor: var(--color-grey);\n\tmargin-bottom: 8px;\n}\n\n.cocktail-block {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 8px;\n\tmargin-bottom: 20px;\n\tzoom: var(--zoom);\n\n\t.cocktail {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t}\n\n\t.cocktail-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 135%;\n\t\ttext-align: center;\n\n\t\ttext-wrap: balance;\n\t}\n}\n\n// Order Details Section\n.order-details {\n\tmargin-bottom: 24px;\n\tpadding-bottom: 24px;\n\tpadding-top: 24px;\n\tborder-bottom: 0.5px solid #939393;\n\tborder-top: 0.5px solid #939393;\n\n\t.detail-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 16px;\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t.detail-label {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 8px;\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #5c5c5c;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tcolor: #5c5c5c;\n\t\t\t}\n\t\t}\n\n\t\t.detail-value {\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #1d1d1b;\n\t\t\ttext-align: right;\n\n\t\t\t.order-number {\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Preparing Status\n.preparing-status {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tcolor: #5c5c5c;\n\tfont-size: 13px;\n\n\tion-spinner {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n}\n\n// Download Receipt Button\n.download-receipt {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tpadding: 6px 12px;\n\tbackground: var(--ion-color-secondary);\n\tcolor: white;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background 0.2s;\n\n\t&:hover {\n\t\tbackground: var(--ion-color-secondary-tint);\n\t}\n\n\tspan {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tcolor: #000;\n\t}\n\n\tion-icon {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n}\n\n// Order Items Section\n.order-items {\n\tmargin-bottom: 24px;\n\n\t.item-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 12px;\n\n\t\t.item-info {\n\t\t\tdisplay: flex;\n\t\t\tgap: 8px;\n\t\t\tflex: 1;\n\n\t\t\t.item-quantity {\n\t\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: #1d1d1b;\n\t\t\t}\n\n\t\t\t.item-name {\n\t\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: #1d1d1b;\n\t\t\t}\n\t\t}\n\n\t\t.item-price {\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: #1d1d1b;\n\t\t\twhite-space: nowrap;\n\t\t\tmargin-left: 16px;\n\t\t}\n\t}\n\n\t.item-option {\n\t\tpadding-left: 32px;\n\t\tmargin-bottom: 8px;\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 13px;\n\t\tcolor: #5c5c5c;\n\t}\n\n\t.tip-row {\n\t\tmargin-top: 16px;\n\t\tpadding-top: 16px;\n\t\tborder-top: 1px dashed #e0e0e0;\n\t}\n}\n\n// Miles & More Section\n.miles-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 16px;\n\tpadding-top: 16px;\n\tborder-top: 1px dashed #e0e0e0;\n\n\t.miles-img {\n\t\theight: 18px;\n\t\twidth: auto;\n\t}\n\n\t.miles-value {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: #226086;\n\t}\n}\n\n// Total Section\n.total-section {\n\tpadding: 20px 0;\n\tborder-top: 0.5px solid #939393;\n\n\t.total-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t.total-label,\n\t\t.total-amount {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -0.01em;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: #000000;\n\t\t}\n\t}\n}\n\n// Review Section\n.review-section {\n\ttext-align: center;\n\n\t.review-button {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgap: 8px;\n\t\tpadding: 12px 24px;\n\t\tbackground: var(--ion-color-primary);\n\t\tborder: 0.5px solid #000;\n\t\tbox-shadow: 1px 1px 0px 1px #000;\n\n\t\tborder-radius: 4px;\n\t\tcursor: pointer;\n\t\ttransition: background 0.2s;\n\t\twidth: 278px;\n\t\theight: 44px;\n\t\tcolor: #000000;\n\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: inherit;\n\n\t\t\t&:last-child {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t}\n\t\t}\n\n\t\tion-icon {\n\t\t\theight: 18px;\n\t\t\twidth: 18px;\n\t\t\tmargin-right: 5px;\n\t\t}\n\n\t\t.feedback-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n// Footer Message\n.footer-message {\n\ttext-align: center;\n\tmargin-bottom: 16px;\n\tmargin-top: auto;\n\n\tp {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 1.5;\n\t\tcolor: #5c5c5c;\n\t\tmargin: 0;\n\t}\n}\n\nion-footer {\n\tpadding: 16px;\n\tbackground: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);\n\tbackdrop-filter: blur(4px);\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n\t.payment-success-content .container {\n\t\theight: 100%;\n\t\tpadding: 26px 16px;\n\t}\n\n\t.success-card {\n\t\tpadding: 20px 12px;\n\t}\n\n\t.logo-section .brand-logo {\n\t\twidth: 220px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.detail-row {\n\t\talign-items: flex-start !important;\n\t\tgap: 8px;\n\n\t\t.detail-value {\n\t\t\ttext-align: left !important;\n\t\t}\n\t}\n\n\t.order-details .detail-row .detail-label {\n\t\tfont-size: 13px;\n\t}\n\n\t.order-details .detail-row .detail-value {\n\t\tfont-size: 13px;\n\t}\n}\n\n// Loading State\n.loading-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 9999;\n\n\tion-spinner {\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tcolor: white;\n\t}\n}\n\n// Error State\n.error-message {\n\tbackground: #ffebee;\n\tcolor: #c62828;\n\tpadding: 12px 16px;\n\tborder-radius: 4px;\n\tmargin-bottom: 16px;\n\ttext-align: center;\n\tfont-family: 'AppFont', sans-serif;\n\tfont-size: 14px;\n}\n\n// Status Tabs\n.status-tabs {\n\tdisplay: flex;\n\tgap: 10px;\n\tmargin-bottom: 20px;\n\t--local-color: var(--ion-color-secondary);\n\n\t.status-tab {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s ease;\n\n\t\t.status-indicator {\n\t\t\twidth: 100%;\n\t\t\theight: 10px;\n\t\t\tbackground: #e0e0e0;\n\t\t\ttransition: background 0.3s ease;\n\t\t}\n\n\t\tspan {\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 13px;\n\t\t\tcolor: #1a1a18;\n\t\t}\n\n\t\t&.active {\n\t\t\t.status-indicator {\n\t\t\t\tbackground: var(--local-color);\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
